<template>
	<div v-loading="loading">
		<el-button type="primary" @click="plsc" size="small" style="margin-left: 10px;">导入排班</el-button>
		<input type="file" name="file" style="opacity: 0;position: absolute;display: none;" id="sj"
			@change="xuanzhe($event)" />
		<div class="first_line">
			<div class="right_warp">
				<el-select class="jul" size="small" v-model="filter.storeId" style="margin-right:10px;" filterable>
					<el-option v-for="item in statelist" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				<el-date-picker size="small" value-format="yyyy-MM-dd" v-model="filter.times" type="daterange"
					range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
				</el-date-picker>
				<el-button class="jul" type="primary" @click="getlist()" size="small">筛选</el-button>
				<!-- <el-button class="jul" type="primary" @click="exportss" size="small">导出</el-button> -->
			</div>
		</div>
		<div>
			<el-row :gutter="24">
				<el-col :span="16">
					<div style="background-color: #eaeaea;min-height: 100px; padding: 0 10 0 10;">
						<p2 style="padding: 5px;">机动组</p2>
						<div style="display: flex;flex-wrap: wrap;">
							<!-- <div v-if="userCoupon == null || userCoupon.length==0" style="color: #787878; ">
								-暂无机动组成员-
							</div> -->
							<div v-for=" i in workerList" v-if="i.motor==1" style="margin-right: 15px;">
								<el-tag :closable="jidongShow" @close="deljiDong(i.id,0)" class="jidongbtn">{{i.name}}
								</el-tag>
							</div>
						</div>
					</div>
				</el-col>
				<el-col :span="8">
					<div style="min-height: 100px;float: left;">
						<el-button type="primary" size="small" @click="firstAddJiDong()">
							添加</el-button>
						<el-button type="primary" size="small" @click="jidongShow=!jidongShow">
							移除</el-button>
					</div>
				</el-col>
			</el-row>
			<el-row :gutter="24">
				<el-col :span="16">
					<div class="calendar" style="margin-top: 10px">
						<el-calendar v-model="newrili" :range="filter.times">
							<template slot="dateCell" slot-scope="{date, data}" class="rilis">
								<div style="width:100%; height: 100%;" @click="saveTmpDate(date),rostreByDate(date)">
									<div>
										{{data.day.substring(5)}}
										<div style="font-size:14px">
											{{ zhuan(data.day) }}
										</div>
									</div>
								</div>
							</template>
						</el-calendar>
					</div>
				</el-col>
				<el-col :span="8" style="margin: 10 0 0 0;" v-loading="loading2">
					<div style="background-color: #eaeaea; padding: 15px 5px 5px 10px;margin-top: 20px">
						<div style="margin: 5px 5px; font-size:18px;"><b>门店发型师</b></div>
						<span v-for="worker in storeWorker" :key="worker.id" style="margin: 5px;">
							<span style="display: table-caption;">
								<el-avatar :size="70" :src="worker.avatar"></el-avatar>
								<span style="margin-left: 10px">{{ worker.name }}</span>
								<div style="margin-left: 10px;">
									<el-popover v-if="restWorker.filter(ele => ele.name==worker.name).length>0"
										width="200" trigger="click">
										<el-button type="text" size="small" slot="reference"
											@click="selectObj.name=worker.name,selectObj.phone=worker.telphone"
											class="upbtn">上班</el-button>
										<div>
											<div v-for="item in rosterList" :key="item.id"
												style="margin: 5px 5px 10px 5px;">
												<el-radio v-model="selectObj.droster" :label="item.desc">
													<span>{{ item.startWorkTime.substring(0, 5) + "-" + item.endWorkTime.substring(0, 5) }}</span>
												</el-radio>
											</div>
											<div style="margin-left:150px">
												<el-button type="text" size="mini" @click="workRoster(worker.id,0)">保存
												</el-button>
											</div>
										</div>
									</el-popover>
									<el-button type="text" size="small"
										@click="rosterShow=true,selectObj.outWorker=worker.name">调店</el-button>
								</div>
							</span>
						</span>
					</div>
					<div style="background-color: #eaeaea; padding: 5px">
						<!-- <div style="margin: 0px 5px; font-size:18px;"><b>调店的发型师</b></div>
						<div>暂无</div> -->
						<!-- <span v-for="worker in storeWorker" :key="worker.id" style="margin: 5px;">
							<span style="display: table-caption;">
								<el-avatar :size="70" :src="worker.avatar"></el-avatar>
								<span style="margin-left: 10px">{{ worker.name }}</span>
							</span>
						</span> -->
					</div>
					<div style="background-color: #eaeaea; padding: 10px;">
						<el-row>
							<el-col :span="6" class="bigText">{{this.selectObj.date}}</el-col>
							<el-col :span="5" class="bigText">午餐时间</el-col>
							<el-col :span="6" class="bigText">晚餐时间</el-col>
							<el-col :span="5" class="bigText">操作</el-col>
						</el-row>
						<el-row>
							<div v-for="item in rosterList" :key="item.id" style="margin: 6px;">
								<span
									style="font-size: 16px;font-family: siyuan;">{{ item.startWorkTime.substring(0, 5) + "-" + item.endWorkTime.substring(0, 5) }}</span>
								<div v-for="worker in item.workers" :key="worker.name"
									style="margin: 5px 10px;display: flex;">
									<div style="width: 100px;">{{ worker.name }}</div>
									<div style="width: 100px;display: flex;margin-left: 10px;">
										<div v-if="worker.lunchStartTime !=null">
											{{ worker.lunchStartTime | eTime}}~{{worker.lunchEndTime | eTime}}
										</div>
										<div v-else>未设置</div>
									</div>
									<div style="width: 100px; margin-left: 5px;">
										<div v-if="worker.dinnerStartTime !=null">
											{{ worker.dinnerStartTime | eTime}}~{{worker.dinnerEndTime | eTime}}
										</div>
										<div v-else>未设置</div>
									</div>
									<div style="padding-left:5%;">
										<!-- <el-button type="text" size="mini" @click="workRoster(worker.id)" style="margin-right:10px;">休息</el-button> -->
										<el-button type="text" size="mini" slot="reference"
											@click="deleteRoster(worker.id)"
											style="font-size: 15px; color: #F43838;font-family: siyuan;">
											休息</el-button>
										<el-button type="text" size="mini" slot="reference" @click="changeTime(worker)"
											style=" font-size: 15px; color: #58a531;font-family: siyuan;">
											就餐</el-button>
										<span>
											<el-popover width="200" trigger="click">
												<el-button type="text" size="mini" slot="reference"
													@click="selectObj.id=worker.id"
													style="margin-left: 10px;font-size: 15px; font-family: siyuan;">调班
												</el-button>
												<div>
													<div v-for="item in rosterList" :key="item.id"
														style="margin: 5px 5px 10px 5px;">
														<el-radio v-model="selectObj.droster" :label="item.desc"
															v-if="worker.droster!=item.desc">
															<span>{{ item.startWorkTime.substring(0, 5) + "-" + item.endWorkTime.substring(0, 5) }}</span>
														</el-radio>
													</div>
													<div style="margin-left:150px">
														<el-button type="text" size="mini"
															@click="workRoster(worker.id,0)" slot="reference">保存
														</el-button>
													</div>
												</div>
											</el-popover>
										</span>
									</div>
								</div>
							</div>
						</el-row>
						<!-- 
						<div style="display: flex;">
							<div style="margin: 0px 5px; font-size:20px; color: #000000;font-family: SourceHanSansCN-Bold;">
									
							</div>
							<div style="margin: 0px 15px; font-size:20px; color: #000000;font-family: SourceHanSansCN-Bold;">
									
							</div>
							<div style="margin: 0px 15px; font-size:20px; color: #000000;font-family: SourceHanSansCN-Bold;">
									晚餐时间
							</div>
						</div> -->
					</div>
				</el-col>
			</el-row>
		</div>
		<el-dialog :visible.sync="addWorker" @close="close" width="20%">
			<div style="font-size: 16px; height:auto; margin-bottom:5px;">
				<!-- <template slot-scope="scope"> -->
				<div style="text-align:center;vertical-align:middel;">
					<p1>添加发型师</p1>
					</br>
					<input type="text" v-model="workerList1.name" @keydown.enter="getWorkerList1(workerList1.name)"
						placeholder="输入发型师姓名" style="font-size:15px;padding: 5px;margin:15px;">
				</div>
				<div>
					<el-radio-group v-model="radio">
						<el-radio v-for="j in workerList1" v-if="j.status!=8"
							@click.native.prevent="check1(j.id)">{{j.name}}———{{j.storeName}}</el-radio>
						<!-- <el-radio v-for="j in workerList1" v-if="j.status!=8" @change="check1(j.id)">{{j.name}}———{{j.storeName}}</el-radio> -->
					</el-radio-group>
				</div>
				<el-button type="primary" style="margin-left: 40%; margin-top: 15px;"
					@click="saveWorkerStatus(jiDongcheck,1)">确定
				</el-button>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="rosterShow" @close="close" width="30%">
			<div style="font-size: 16px; margin-bottom:10px;">
				<b style="font-size:16px;">所选发型师：</b>
				<span>
					{{ selectObj.outWorker }}
				</span>
			</div>
			<div style="font-size: 16px; margin-bottom:10px;">
				<b style="font-size:16px;">排班时间：</b>
				<span>
					{{ selectObj.date }}
				</span>
			</div>
			<div style="font-size: 16px; font-weight:700; margin-bottom:10px;">
				<b style="font-size:16px;">门店选择：</b>
				<el-select v-model="selectObj.outStorename" filterable @change="getRosters" size="small"
					style="width:300px;">
					<el-option v-for="item in statelist" :key="item.label" :label="item.label" :value="item.label">
					</el-option>
				</el-select>
			</div>
			<div style="height:100px;">
				<b style="font-size:16px;">班次选择：</b>
				<el-select v-model="outRoster" filterable :disabled="storeRosters.length==0" size="small"
					style="width:300px;">
					<el-option v-for="item in storeRosters" :key="item.desc" :label="item.desc" :value="item.desc">
					</el-option>
				</el-select>
			</div>
			<div>
				<el-button type="primary" style="margin-left:70%" @click="outStore">保存</el-button>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="changetime" width="30%">
			<el-form label-width="70px" label-position="left">
				<el-form-item label="日期">
					{{worker.date}}
				</el-form-item>
				<el-form-item label="班次">
					{{worker.droster}}
				</el-form-item>
				<el-form-item label="发型师">
					{{worker.name}}
				</el-form-item>
				<el-form-item label="午餐">
					<el-select v-model="worker.lunchStartTime" placeholder="午餐开始时间" clearable size="small"
						class="wtime">
						<el-option v-for="item in timeLunchStartList" :key="item.value" :value="item.value"
							:label="item.value"></el-option>
					</el-select>
					~
					<el-select v-model="worker.lunchEndTime" placeholder="午餐结束时间" clearable size="small" class="wtime"
						style="font-size: 18px;">
						<el-option v-for="item in timeLunchEndList" :key="item.value" :value="item.value"
							:label="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="晚餐">
					<el-select v-model="worker.dinnerStartTime" placeholder="晚餐开始时间" clearable size="small"
						class="wtime">
						<el-option v-for="item in timeDinnerStartList" :key="item.value" :value="item.value"
							:label="item.value"></el-option>
					</el-select>
					~
					<el-select v-model="worker.dinnerEndTime" placeholder="晚餐结束时间" clearable size="small" class="wtime">
						<el-option v-for="item in timeDinnerEndList" :key="item.value" :value="item.value"
							:label="item.value"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div style="margin-left: 70%;">
				<el-button @click="changetime=false">取消</el-button>
				<el-button @click="saveChange()" type="primary">保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	let that
	import {
		url
	} from "../../../utils/index.js"
	export default {
		inject: ['reload'],
		data() {
			return {
				worker: {},
				changetime: false,
				loading: false,
				loading2: false,
				del: false,
				outRoster: undefined,
				url: url(),
				filter: {
					city: "", //城市
					times: [new Date().getUTCFullYear() + '-' + (new Date().getMonth() + 1) + "-01",
						new Date().getUTCFullYear() + '-' + (new Date().getMonth() + 2) + "-" + (new Date(new Date()
							.getFullYear(), new Date().getMonth() + 1, 1).getDate())
					],
					startTime: "", // 开始时间
					endTime: "", // 结束时间
					storeId: 7 // 门店ID
				},
				workerName: "", //输入的发型师名
				selectDate: '', //点击日历的日期
				workerList: {
					id: '',
					name: "",
					storeName: "",
					motor: '',
				},
				workerList1: {
					id: '',
					name: "",
					storeName: "",
					motor: '',
					status: "",
				},
				jiDongcheck: undefined,
				// i: {},
				// workerList1: [], //按名字查
				restWorker: [],
				addWorker: false,
				rosterShow: false,
				closable: false,
				jidongShow: true,
				radio: {},
				statelist: [],
				selectObj: {
					date: undefined,
				},
				sdate: '', //选择的门店
				storeWorker: [],
				selectWorkers: [],
				citys: [],
				newrili: new Date(), // 日历
				list: [],
				times: "",
				rosterList: [],
				otherWorker: [],
				storeRosters: [],
				timeLunchStartList: [{
					id: 0,
					value: '13:00:00'
				}, {
					id: 1,
					value: '13:15:00'
				}, {
					id: 2,
					value: '13:30:00'
				}, {
					id: 3,
					value: '13:45:00'
				}, ],
				timeLunchEndList: [{
					id: 0,
					value: '13:15:00'
				}, {
					id: 1,
					value: '13:30:00'
				}, {
					id: 2,
					value: '13:45:00'
				}, {
					id: 3,
					value: '14:00:00'
				}],
				timeDinnerStartList: [{
					id: 4,
					value: '18:00:00'
				}, {
					id: 5,
					value: '18:15:00'
				}, {
					id: 6,
					value: '18:30:00'
				}, {
					id: 7,
					value: '18:45:00'
				}, {
					id: 8,
					value: '19:00:00'
				}, {
					id: 9,
					value: '19:30:00'
				}, ],
				timeDinnerEndList: [{
					id: 4,
					value: '18:15:00'
				}, {
					id: 5,
					value: '18:30:00'
				}, {
					id: 6,
					value: '18:45:00'
				}, {
					id: 1,
					value: '19:00:00'
				}, {
					id: 2,
					value: '19:30:00'
				}, {
					id: 3,
					value: '20:00:00'
				}]
			};
		},
		created() {
			that = this;
		},
		mounted() {
			this.getstorelist();
			this.getWorkerList();
			this.getRosterList();
		},
		// export const watch = (obj: Obj, name: string, func: (value: any) => void) => {
		//   Object.defineProperty(obj, name, {
		//     get: function() {
		//       return obj;
		//     },
		//     set: newValue => {
		//       func && func(newValue);
		//     },
		//   });
		// };
		// watch(data, 'jidongShow', newValue => {
		//   return newValue;
		// });
		computed: {
			zhuan: () => {
				return (value) => {
					if (!that.list) return null
					let str = "";
					that.list.filter(ele => str += ele.date == value ? ele.name + "," : "");
					return str.substring(0, str.length - 1);
				}
			}
		},
		filters: {
			eTime(val) {
				if (val != null) {
					val = val.slice(0, 5)
				}
				return val;
			}
		},
		methods: {
			exportss() {
				let urls
				urls = this.url + "dcheckuser/exporDroster?pageNum=1" + "&storeId=" + this.filter.storeId
				if (this.filter.times) {
					urls = this.url + "dcheckuser/exporDroster?pageNum=1" + "&startTime=" + this.filter.times[0] +
						"&endTime=" + this.filter.times[1] + "&storeId=" + this.filter.storeId
				}
				window.location.assign(urls)
			},
			getRosterList() {
				this.$http.get("dcheckuser/rosterGroup/store/" + this.filter.storeId).then(res => {
					this.rosterList = res.body.data
					let date = new Date();
					if (this.sdate != null && this.sdate != '' && this.sdate != undefined && this.sdate !=
						'undefined') {
						this.rostreByDate(this.sdate);
					} else {
						this.rostreByDate(date.getUTCFullYear() + '-' + (date.getMonth() + 1) + "-" + date
							.getDate());
					}
				})
			},
			getRosters(event, item) {
				var id = this.statelist.filter(ele => event == ele.label)[0].value
				this.$http.get("dcheckuser/rosterGroup/store/" + id).then(res => {
					this.storeRosters = res.body.data
				})
			},
			selectWorker(roster) {
				let arr = [];
				roster.workers.forEach(ele => {
					arr.push(ele.name)
				});
				this.selectObj.selectRoster = JSON.parse(JSON.stringify(roster));
				this.selectWorkers = arr;
				this.rosterShow = true;
			},
			saveWorkerStatus(id, motor) {
				var arr = {
					id: id,
					motor: 1
				}
				this.$http.post("dWorker/saveOrUpdate", JSON.stringify(arr)).then(res => {
					if (res.body.code == 200) {
						this.$message.success("更改成功")
						this.addWorker = false
						this.getWorkerList()
					}
				})
				this.addWorker = false
			},
			check1(n) {
				this.jiDongcheck = n
			},
			getWorkerList1(name) {
				this.$http.get("dWorker/queryAll" + "?name=" + name).then(res => {
					this.workerList1 = res.body.data;
				})
			},
			deljiDong(id, motor) {
				this.$confirm('移除该发型师, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var a = {
						id: id,
						motor: 0
					}
					this.$http.post("dWorker/saveOrUpdate", JSON.stringify(a)).then(res => {
						if (res.body.code == 200) {
							this.$message.success("移除成功")
						} else {
							this.$message.success("移除失败")
						}
						this.getWorkerList()
					})
				})
			},
			firstAddJiDong() {
				this.workerList1 = {}
				this.addWorker = true
			},
			getWorkerList() {
				this.$http.get("dWorker/query?filterOut=1").then(res => {
					this.workerList = res.body.data;
					this.worker = res.body.data;
					this.storeWorker.length = 0;
					this.storeWorker = this.workerList.filter(ele => ele.storeId == this.filter.storeId);
				})
			},
			// 休息
			deleteRoster(id) {
				this.$confirm("是否确定休息?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					this.loading = false
					this.$http.get("dcheckuser/deleteRoster" + "?id=" + id).then(res => {
						if (res.body.code == 200) {
							this.loading = false
							this.rostreByDate(this.selectObj.date);
							this.getlist();
							this.selectObj.workerId = undefined;
							this.selectObj.droster = undefined;
							this.$message.success("休息成功");
						} else {
							this.$message.error(res.body.msg)
						}
					})
				})
			},
			// 新增排班
			workRoster(id, type) {
				this.loading = true
				if (!id) {
					if (!this.selectObj.droster) return this.$message.error("保存失败，没有选择班次！");
				}
				this.selectObj.storeName = this.statelist.filter(res => res.value == this.filter.storeId)[0].label
				this.selectObj.storeId = this.filter.storeId
				this.selectObj.selectDate = this.selectDate
				this.selectObj.workerId = id
				// this.selectObj.id = id
				if (type != null) {
					this.selectObj.type = type
				}
				this.$http.post("dcheckuser/roster/work", JSON.stringify(this.selectObj)).then(res => {
					if (res.body.code == 200) {
						this.loading = false
						this.rostreByDate(this.sdate);
						// this.rostreByDate(this.selectObj.date);
						this.getlist();
						this.selectObj.workerId = undefined;
						this.selectObj.droster = undefined;
						this.$message.success("保存成功")
					} else {
						this.loading = false
						this.$notify({
							title: '排班重复',
							message: res.body.msg,
							customClass: "not", //自定义类名
							duration: 0
						});
					}
				})
			},
			handleClose(item) {
				this.$confirm('移除该发型师, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var a = {
						id: item.id,
						userId: item.userId,
						couponTitle: item.title,
						code: item.code
					}
					this.$http.post("user/deleteCoupon", JSON.stringify(a)).then(res => {
						if (res.body.code == 200) {
							this.getInfo()
							this.$message.success("移除成功")
						} else {
							this.$message.success("移除失败")
						}
					})
				}).catch(() => {
					this.$message.success("已取消移除")
				});
			},
			close() {
				this.selectObj.outWorker = undefined;
				this.outRoster = undefined;
				this.selectObj.outStorename = undefined;
				this.storeRosters = [];
			},
			outStore() {
				let data = {
					date: this.selectObj.date,
					worker: this.selectObj.outWorker,
					roster: this.outRoster,
					storeName: this.selectObj.outStorename
				};
				this.$http.post("dcheckuser/updateRoster", JSON.stringify(data)).then(res => {
					if (res.body.code == 200) {
						this.getlist();
						setTimeout(() => this.rostreByDate(this.selectObj.date), 1000);
						this.rosterShow = false;
						this.$message.success("保存成功")
					} else {
						this.$message.error(res.body.msg)
					}
				})
			},
			rostreByDate(date) {
				// this.loading2 = true
				let type = Object.prototype.toString.call(date);
				type = type.substring(8, type.length - 1);
				let data;
				if (type === 'String') {
					data = {
						storeId: this.filter.storeId,
						date: date,
					}
				} else {
					data = {
						storeId: this.filter.storeId,
						date: date.getUTCFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate(),
					}
				}
				this.selectObj.date = data.date;
				this.$http.post("dcheckuser/rosterByDate", JSON.stringify(data)).then(res => {
					if (res.body.code == 200) {
						var b = {
							edit: false
						}
						this.rosterList.forEach(ele => {
							let d = res.body.data.filter(worker => worker.droster == ele.desc);
							this.$set(ele, 'workers', d);
							// if(ele.workers !=null && ele.workers.length>0){
							// 	ele.workers.forEach(w =>{
							// 		this.$set(w, 'edit', false);
							// 	})
							// }
						})
						this.restWorker.length = 0;
						this.storeWorker.forEach(ele => {
							if (res.body.data.filter(worker => worker.name == ele.name).length == 0) this
								.restWorker.push(ele);
						})
						this.loading2 = false
					}
				})
			},
			changeTime(worker) {
				this.changetime = true
				this.worker = worker
			},
			saveChange(worker) {
				var c = this.worker
				var x = new Date().getFullYear();
				var ls = new Date(x + '-01-01 ' + c.lunchStartTime)
				var le = new Date(x + '-01-01 ' + c.lunchEndTime)
				var ds = new Date(x + '-01-01 ' + c.dinnerStartTime)
				var de = new Date(x + '-01-01 ' + c.dinnerEndTime)
				if ((le.getTime() - ls.getTime() > 0) || (c.lunchStartTime == null && c.lunchEndTime == null)) {
					if ((de.getTime() - ds.getTime() > 0) || (c.dinnerStartTime == null && c.dinnerEndTime == null)) {
						var a = {
							id: c.id,
							lunchStartTime: c.lunchStartTime,
							lunchEndTime: c.lunchEndTime,
							dinnerStartTime: c.dinnerStartTime,
							dinnerEndTime: c.dinnerEndTime
						}
						this.$http.post("dcheckuser/roster/changeEatTime", JSON.stringify(a)).then(res => {
							if (res.ok == true) {
								this.$message.success("修改成功")
								this.changetime = false
								this.rostreByDate(this.sdate)
								this.worker = {}
							} else {
								this.$message.error("修改失败")
							}
						})
					} else {
						this.$message.error("晚餐结束时间不能小于等于开始时间")
					}
				} else {
					this.$message.error("午餐结束时间不能小于等于开始时间")
				}
			},
			getstorelist() {
				this.$http.get("store/list").then((res) => {
					if (res.body.code == "200") {
						this.statelist = []
						res.body.data.filter(ele => ele.businessType == 0).forEach(ele => {
							this.statelist.push({
								value: ele.id,
								label: ele.title
							})
						})
						this.getlist();
					} else {
						this.$message.error("请求失败")
					}
				})
			},
			// 文件上传
			plsc: function() {
				var sj = document.querySelector('#sj')
				sj.click()
			},
			xuanzhe: function(val) {
				var sj = document.querySelector('#sj')
				let Formdata = new FormData;
				Formdata.append('file', val.target.files[0])
				let config = {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}
				var that = this
				this.$http.post("dcheckuser/drosterCheckUserImport", Formdata, config).then(function(res) {
					if (res.body.code == 200) {
						this.$message.success("导入成功")
						this.rostreByDate(this.selectObj.date)
						this.getRosterList()
						this.getlist()
					} else {
						this.$message.error(res.body.msg)
					}
					// var t0 = setTimeout(function() {
					// 	this.$message.info("页面即将刷新")
					// },1000);
					var t = setTimeout(function() {
						// location.reload()
						// this.$router.go(-1)
						// this.$parent.reload()
						// this.reload();
						that.reload()
					}, 4000);
				})
			},
			getlist() {
				let arr = {
					pageNum: 1,
					storeId: this.filter.storeId,
				}
				this.statelist.map(ele => {
					if (ele.value == arr.storeId) arr.name = ele.label
				})
				if (this.filter.times) {
					arr.startTime = this.filter.times[0]
					arr.endTime = this.filter.times[1]
				}
				this.$http.post("dcheckuser/findDSchedulingDate", JSON.stringify(arr)).then(function(res) {
					this.list = res.body.data
					this.getWorkerList();
					setTimeout(() => this.getRosterList(), 1000);
				})
			},
			saveTmpDate(date) {
				this.sdate = date
			}
		},
	};
</script>
<style lang="less" scoped>
	.first_line {
		margin: 20px 0;
		display: flex;
		justify-content: space-between;

		.right_warp {
			display: flex;
			align-items: center;
			font-size: 16px;
			color: #3e3e3e;

			.el-select {
				width: 120px;
			}

			.el-input {
				width: 180px;
			}

			.jul {
				margin-left: 10px;
			}
		}
	}

	.pagescg {
		margin-top: 20px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	.upbtn {
		margin-right: 5px;
	}

	.jidongbtn {
		color: #000;
		margin: 5px;
		background-color: #fff;
		border: #d7d7d6;
		padding: 5px;
	}

	.el-notification {
		white-space: pre !important;
	}

	.not {
		word-wrap: break-word;
		word-break: break-all;
	}

	.bigText {
		font-size: 20px;
		color: #000000;
		font-family: SourceHanSansCN-Bold;
	}

	.wtime {
		width: 150px;
	}

	/deep/ .el-input__inner {
		-webkit-appearance: none;
		background-color: transparent;
		background-image: none;
		border-radius: 4px;
		border: 1px solid #DCDFE6;
		box-sizing: border-box;
		color: #606266;
		// display: inline-block;
		font-size: 15px;
		height: 40px;
		line-height: 40px;
		// outline: 0;
		// padding: 0 15px;
		// transition: border-color .2s cubic-bezier(.645,.045,.355,1);
		// width: 100%;
	}
</style>